import Constants from "../constants/constants";
import {httpGet} from "./api/axios_api";
import {game} from './api/entities';

const actions = {
    getGameList: "GET_GAME_LIST"
}

export async function getGameByName(gameName, token) {
    let url = `${Constants.BACKEND_URL}/get-game-by-name/` + gameName;
    return httpGet(url, {}, token);
}

export function getGameList(query, sort){
    const _query = [...query, {archived:false}]
    return game.list(actions.getGameList, _query, sort)
}

// export async function getGames(token) {
//     let url = `${Constants.BACKEND_URL}/games`;
//     return httpGet(url, {}, token);
// }

const INITIAL_STATE = {
    games:[]
}

export default function reducer(state=INITIAL_STATE, action){
    switch(action){
        case actions.getGameList:
            console.log("   ~~~ Eve retireve games")
            console.log(action)
            return{
                ...state,
                games: action.body? action.body._items: state.games
            }
        default:
            return {...state}
    }
}


// WEBPACK FOOTER //
// ./src/modules/game.js